<template>
  <div class="talent">
    <!-- 头部 -->
    <a-spin v-if="!user">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
    <div v-else>
      <div
        class="tanlent-header"
        :style="{ borderBottom: talentBottom ? '1px solid #ebebeb' : 'none' }"
      >
        <img v-if="user.avatar" :src="getImgUrl(user.avatar)" />
        <a-avatar v-else shape="square" :size="214" icon="user" />
        <div class="tanlent-header-text">
          <div class="tanlent-header-title">
            <div class="tanlent-header-left">
              <h5>{{ user.info ? user.info.realname : "" }}</h5>
              <span>
                {{ user.info ? user.info.education + " · " : "未填写 · "
                }}{{ user.info ? `工作经验 ${user.info.jobExperiences}` : "" }}
              </span>
            </div>
            <headerIcon
              :edit="true"
              :Action="ActionTitle"
              to="/user/talent/basicForm"
            ></headerIcon>
          </div>
          <p>{{ user.info ? user.info.advantage : "" }}</p>
        </div>
      </div>
      <!-- 求职意向 -->
      <div class="tanlent-content" v-if="TalentList[1].data">
        <div>
          <div class="tanlent-title">
            <div class="tanlent-content-title">
              <img src="@/assets/img/person/job.png" alt />
              <h3>求职意向</h3>
            </div>
            <headerIcon
              :add="true"
              to="/user/talent/jobForm"
              :Action="ActionForm"
            ></headerIcon>
          </div>
          <div v-for="(item, index) in user.intentions" :key="index">
            <div class="tanlent-context">
              <i></i>
              <div class="tanlent-context-text">
                <div class="tanlent-text-flex">
                  <div class="tanlent-left" v-if="item.form">
                    <h6>{{ item.form.name }}</h6>
                  </div>
                  <headerIcon
                    :edit="true"
                    :dele="true"
                    :id="item.id"
                    to="/user/talent/jobForm"
                    :Action="ActionType"
                    :formId="item.formId"
                  ></headerIcon>
                </div>
                <b-row>
                  <b-col
                    cols="12"
                    md="4"
                    v-for="(items, indexs) in item.records"
                    :key="indexs"
                  >
                    <p>{{ JSON.parse(items.field).fieldTitle }} :</p>
                    <span
                      v-if="
                        JSON.parse(items.field).fieldType == 'upload' &&
                          items.value !== ''
                      "
                      >{{ JSON.parse(items.value).name + " " }}</span
                    >
                    <span v-else>{{ items.value }}</span>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 工作经历 -->
      <div class="tanlent-content" v-if="TalentList[2].data">
        <div class="tanlent-title">
          <div class="tanlent-content-title">
            <img src="@/assets/img/person/work.png" alt />
            <h3>工作经历</h3>
          </div>
          <headerIcon
            :add="true"
            to="/user/talent/workForm"
            :Action="ActionForm"
          ></headerIcon>
        </div>
        <div
          class="tanlent-context"
          v-for="(item, index) in user.historyJobs"
          :key="index"
        >
          <i></i>
          <div class="tanlent-context-text">
            <div class="tanlent-text-flex">
              <div class="tanlent-left">
                <h6>{{ item.company ? item.company : "" }}</h6>
                <span>
                  {{ item.duty ? item.duty : "未填写" }}丨{{
                    item.department ? item.department : "未填写"
                  }}丨{{
                    item.leaveTime
                      ? $moment(item.enterTime).format("YYYY-MM-DD") +
                        "-" +
                        $moment(item.leaveTime).format("YYYY-MM-DD")
                      : $moment(item.enterTime).format("YYYY-MM-DD") + "-未离职"
                  }}
                </span>
              </div>
              <headerIcon
                :edit="true"
                :dele="true"
                :id="item.id"
                to="/user/talent/workForm"
                :Action="ActionType"
              ></headerIcon>
            </div>
            <p>{{ item.content }}</p>
          </div>
        </div>
      </div>
      <!-- 教育经历 -->
      <div class="tanlent-content" v-if="TalentList[3].data">
        <div class="tanlent-title">
          <div class="tanlent-content-title">
            <img src="@/assets/img/person/educ.png" alt />
            <h3>教育经历</h3>
          </div>
          <headerIcon
            :add="true"
            to="/user/talent/educationForm"
            :Action="ActionForm"
          ></headerIcon>
        </div>
        <div
          class="tanlent-context"
          v-for="(item, index) in user.educations"
          :key="index"
        >
          <i></i>
          <div class="tanlent-context-text">
            <div class="tanlent-text-flex">
              <div class="tanlent-left">
                <h6>{{ item.college ? item.college : "" }}</h6>
                <span>
                  {{ item.type ? item.type + " | " : ""
                  }}{{ item.major ? item.major + " | " : ""
                  }}{{
                    item.enterTime && item.graduationTime
                      ? $moment(item.enterTime).format("YYYY-MM-DD") +
                        "-" +
                        $moment(item.graduationTime).format("YYYY-MM-DD")
                      : ""
                  }}
                </span>
              </div>
              <headerIcon
                :edit="true"
                :dele="true"
                to="/user/talent/educationForm"
                :Action="ActionType"
                :id="item.id"
              ></headerIcon>
            </div>
          </div>
        </div>
      </div>

      <!-- 专业资格证书 -->
      <div class="tanlent-content" v-if="TalentList[4].data">
        <div>
          <div class="tanlent-title">
            <div class="tanlent-content-title">
              <img src="@/assets/img/person/major.png" alt />
              <h3>专业能力</h3>
            </div>
            <headerIcon
              :add="true"
              to="/user/talent/majorForm"
              :Action="ActionForm"
            ></headerIcon>
          </div>
          <div v-for="(item, index) in user.abilities" :key="index">
            <div class="tanlent-context">
              <i></i>
              <div class="tanlent-context-text">
                <div class="tanlent-text-flex">
                  <div class="tanlent-left" v-if="item.form">
                    <h6>{{ item.form.name }}</h6>
                  </div>
                  <headerIcon
                    :edit="true"
                    :dele="true"
                    :id="item.id"
                    to="/user/talent/majorForm"
                    :Action="ActionType"
                    :formId="item.formId"
                  ></headerIcon>
                </div>
                <b-row>
                  <b-col
                    cols="12"
                    md="4"
                    v-for="(items, indexs) in item.records"
                    :key="indexs"
                  >
                    <span style="color:black">
                      {{ JSON.parse(items.field).fieldTitle }} :
                    </span>
                    <span
                      v-if="
                        JSON.parse(items.field).fieldType == 'upload' &&
                          items.value !== ''
                      "
                    >
                      <!-- <a-upload
                    :default-file-list="JSON.parse(items.value)"
                    :headers="headers"
                    action="/api/fs/files"
                      ></a-upload> -->
                      <span
                        v-for="(itemUpload, indexUpload) in JSON.parse(
                          items.value
                        )"
                        :key="indexUpload"
                        >{{ itemUpload.name + " " }}</span
                      >
                    </span>
                    <span v-else>{{ items.value }}</span>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 项目经历 -->
      <div class="tanlent-content" v-if="TalentList[5].data">
        <div class="tanlent-title">
          <div class="tanlent-content-title">
            <img src="@/assets/img/person/project.png" alt />
            <h3>项目经历</h3>
          </div>
          <headerIcon
            :add="true"
            to="/user/talent/projectForm"
            :Action="ActionForm"
          ></headerIcon>
        </div>
        <div
          class="tanlent-context"
          v-for="(item, index) in user.historyProjects"
          :key="index"
        >
          <i></i>
          <div class="tanlent-context-text">
            <div class="tanlent-text-flex">
              <div class="tanlent-left">
                <h6>{{ item.name }}</h6>
                <span>
                  {{ item.role }}丨{{
                    item.endTime
                      ? $moment(item.startTime).format("YYYY-MM") +
                        "-" +
                        $moment(item.endTime).format("YYYY-MM")
                      : $moment(item.startTime).format("YYYY-MM") + "-未结束"
                  }}
                </span>
              </div>
              <headerIcon
                :edit="true"
                :dele="true"
                to="/user/talent/projectForm"
                :Action="ActionType"
                :id="item.id"
              ></headerIcon>
            </div>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
      <div v-for="(item, index) in TalentList" :key="index">
        <div class="talent-list" v-if="!item.data">
          <a @click.stop="createData(item)"
            >{{ item.name }}
            <span v-if="item.must" style="color:red">*</span></a
          >
          <img
            @click.stop="createData(item)"
            src="@/assets/img/new/user/create.png"
          />
        </div>
      </div>
      <a-modal
        class="talent-modal"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
        cancelText="取消"
        okText="确定"
      >
        <template slot="title">
          <div class="modal-icon">
            <img src="@/assets/img/new/user/ts.png" alt />
            {{ title }}
          </div>
        </template>
        <p>{{ ModalText }}</p>
      </a-modal>
    </div>
  </div>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import Api from "@/apis";
export default {
  data() {
    return {
      headers: {},
      to: "",
      id: 0,
      talentBottom: false,
      user: "",
      TalentList: [
        {
          name: "人才信息",
          to: "/user/talent/basicForm",
          data: true
        },
        {
          name: "求职意向",
          to: "/user/talent/jobForm",
          data: false,
          must: true
        },
        {
          name: "工作经历",
          to: "/user/talent/workForm",
          data: false,
          must: true
        },
        {
          name: "教育经历",
          to: "/user/talent/educationForm",
          data: false
        },

        {
          name: "专业能力",
          to: "/user/talent/majorForm",
          data: false
        },

        {
          name: "项目经历",
          to: "/user/talent/projectForm",
          data: false
        }
      ],
      visible: false,
      title: "温馨提示",
      ModalText: "删除后不可恢复,确认删除吗?",
      confirmLoading: false
    };
  },
  mounted() {
    this.getUser();
    const user = JSON.parse(localStorage.getItem("token"));
    let header =
      user && user.accessToken
        ? {
            authorization: user.tokenType + " " + user.accessToken
          }
        : {};
    this.headers = header;
  },
  methods: {
    //获取用户详细信息
    async getUser() {
      try {
        const data = await Api.User.getUserDetail();
        this.user = data;
        if (data) {
          if (
            (data.educations && data.educations.length > 0) ||
            (data.historyJobs && data.historyJobs.length > 0) ||
            (data.abilities && data.abilities.length > 0) ||
            (data.intentions && data.intentions.length > 0) ||
            (data.historyProjects && data.historyProjects.length > 0)
          ) {
            this.talentBottom = true;
          } else {
            this.talentBottom = false;
          }
          //根据数据判断展示
          if (data.intentions && data.intentions.length > 0) {
            this.TalentList[1].data = true;
          } else {
            this.TalentList[1].data = false;
          }
          if (data.historyJobs && data.historyJobs.length > 0) {
            this.TalentList[2].data = true;
          } else {
            this.TalentList[2].data = false;
          }
          if (data.educations && data.educations.length > 0) {
            this.TalentList[3].data = true;
          } else {
            this.TalentList[3].data = false;
          }
          if (data.abilities && data.abilities.length > 0) {
            this.TalentList[4].data = true;
          } else {
            this.TalentList[4].data = false;
          }
          if (data.historyProjects && data.historyProjects.length > 0) {
            this.TalentList[5].data = true;
          } else {
            this.TalentList[5].data = false;
          }
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    createData(item) {
      this.$router.push({
        path: item.to,
        query: {
          type: "add"
        }
      });
    },
    showModal() {
      this.visible = true;
      this.title = "温馨提示";
    },
    handleOk() {
      this.ModalText = "删除后不可恢复,确认删除吗?";
      this.confirmLoading = true;
      setTimeout(async () => {
        if (this.to == "/user/talent/educationForm") {
          const data = await Api.User.deleteEducation(this.id);
          if (data) {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
        } else if (this.to == "/user/talent/workForm") {
          const data = await Api.User.deleteJobHistory(this.id);
          if (data) {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
        } else if (this.to == "/user/talent/projectForm") {
          const data = await Api.User.deleteProjectHistory(this.id);
          if (data) {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
        } else if (this.to == "/user/talent/majorForm") {
          const data = await Api.User.deleteAbilities(this.id, this.formId);
          if (data) {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
        } else if (this.to == "/user/talent/jobForm") {
          const data = await Api.User.deleteIntention(this.id, this.formId);
          if (data) {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
        }
        this.visible = false;
        this.confirmLoading = false;
        this.getUser();
      }, 1000);
    },
    handleCancel() {
      this.visible = false;
    },
    ActionTitle(type, to) {
      this.$router.push({
        path: to,
        query: {
          type: type
        }
      });
    },
    //列按钮处理
    ActionType(type, to, id, formId) {
      if (formId) {
        if (type == "dele") {
          this.visible = true;
          this.to = to;
          this.id = id;
          this.formId = formId;
        } else {
          this.$router.push({
            path: to,
            query: {
              type: type,
              id: id,
              formId: formId
            }
          });
        }
      } else {
        if (type == "dele") {
          this.visible = true;
          this.to = to;
          this.id = id;
        } else {
          this.$router.push({
            path: to,
            query: {
              type: type,
              id: id
            }
          });
        }
      }
    },
    ActionForm(type, to) {
      this.$router.push({
        path: to,
        query: {
          type: type
        }
      });
    },
    onDesc(text) {
      return publicChange.disposeHtml(text);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    getDate(time) {
      return publicChange.getDate(time);
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    }
  }
};
</script>
<style scoped>
.tanlent-context-text h6 {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-bottom: 10px;
}
.tanlent-context-text {
  width: 100%;
}
.tanlent-text-flex {
  display: flex;
}
.tanlent-left {
  flex: 1;
}
.tanlent-context {
  text-align: left;
  display: flex;
  padding: 21px 34px 12px 34px;
}
.tanlent-context i {
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-right: 21px;
  background: #96bfff;
  margin-left: 9px;
  margin-top: 8px;
  border-radius: 50%;
}
.tanlent-context-text span {
  font-size: 16px;
  font-weight: 300;
  color: #999999;
  line-height: 24px;
}
.tanlent-context-text p:first-of-type {
  margin-top: 30px;
}
.tanlent-context-text p {
  font-size: 16px;
  font-weight: 300;
  color: #666666;
  line-height: 24px;
  margin-bottom: 13px;
}
.tanlent-header {
  display: flex;
  align-items: center;
  padding-bottom: 49px;
  padding-left: 34px;
  padding-right: 34px;
}
.tanlent-header-left {
  text-align: left;
  flex: 1;
}

.tanlent-content-title {
  display: flex;
  align-items: center;
  flex: 1;
}
.tanlent-content {
  margin-top: 53px;
}
.tanlent-context:hover {
  background: #fbfcff !important;
}
.tanlent-title {
  display: flex;
  align-items: center;
  margin-bottom: 11px;
  padding-right: 34px;
  padding-left: 34px;
}
.tanlent-content-title img {
  width: 28px;
  height: 28px;
  margin-right: 12px;
}
.tanlent-content-title h3 {
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.tanlent-header h5 {
  font-size: 24px;
  font-weight: 300;
  color: #333333;
  line-height: 36px;
  margin-bottom: 5px;
}
.tanlent-header span {
  font-size: 16px;
  font-weight: 300;
  color: #999999;
  line-height: 24px;
  margin-bottom: 30px;
  display: inline-block;
}
.tanlent-header p {
  font-size: 16px;
  font-weight: 300;
  color: #666666;
  line-height: 24px;
  text-align: left;
}
.tanlent-header img {
  width: 214px;
  height: 214px;
  margin-right: 26px;
}
.tanlent-header-title {
  display: flex;
}
.talent-list a {
  font-size: 24px;
  font-weight: 300;
  color: #333333;
  line-height: 36px;
  flex: 1;
  text-align: left;
}
.talent-list img {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.talent-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 24px;
  margin-bottom: 10px;
  background: #fbfcff;
  margin-left: 34px;
  margin-right: 34px;
}
.modal-icon {
  display: flex;
  align-items: center;
}
.modal-icon img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}
.tanlent-header .ant-avatar {
  min-width: 214px;
  color: #fff !important;
  line-height: 1.5 !important;
  margin-right: 26px;
}
</style>
